import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useCall, useCallStateHooks } from "@stream-io/video-react-sdk";

export const RecordingButton = () => {
  const { t } = useTranslation();
  const call = useCall();
  const { useIsCallRecordingInProgress } = useCallStateHooks();
  const isRecording = useIsCallRecordingInProgress();
  const [loading, setLoading] = useState(false);

  if (!call) return null;

  const handleToggle = async () => {
    setLoading(true);
    try {
      if (isRecording) {
        await call.stopRecording();
      } else {
        await call.startRecording();
      }
    } catch (err) {
      console.error("[RecordingButton] Failed to toggle recording:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleToggle}
      disabled={loading}
      className={`w-12 h-12 rounded-full flex items-center justify-center transition-all relative ${
        isRecording
          ? "bg-red-500/30 text-red-400 hover:bg-red-500/40"
          : "bg-white/10 text-white hover:bg-white/20"
      } ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
      title={isRecording ? t("call.stop_recording") : t("call.start_recording")}
    >
      {isRecording && (
        <span className="absolute top-1.5 right-1.5 w-2 h-2 rounded-full bg-red-500 animate-pulse" />
      )}
      <svg
        className="w-5 h-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        {isRecording ? (
          // Stop icon
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5.25 7.5A2.25 2.25 0 017.5 5.25h9a2.25 2.25 0 012.25 2.25v9a2.25 2.25 0 01-2.25 2.25h-9a2.25 2.25 0 01-2.25-2.25v-9z"
          />
        ) : (
          // Record icon (circle with dot)
          <>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15.91 11.672a.375.375 0 010 .656l-5.603 3.113a.375.375 0 01-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112z"
            />
          </>
        )}
      </svg>
    </button>
  );
};
